/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { WearablesStrictHttpResponse } from '../../wearables-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeviceLinkModel } from '../../models/device-link-model';
import { Platform } from '../../models/platform';

export interface HelpSupportedDevicesPlatformGet$Params {

/**
 * Target platform (e.g., iOS or Android).
 */
  platform: Platform;

/**
 * When true, embeds each device icon as a data-URI (`image/webp`).
 */
  includeImageBase64?: boolean;
}

export function helpSupportedDevicesPlatformGet(http: HttpClient, rootUrl: string, params: HelpSupportedDevicesPlatformGet$Params, context?: HttpContext): Observable<WearablesStrictHttpResponse<Array<DeviceLinkModel>>> {
  const rb = new RequestBuilder(rootUrl, helpSupportedDevicesPlatformGet.PATH, 'get');
  if (params) {
    rb.path('platform', params.platform, {});
    rb.query('includeImageBase64', params.includeImageBase64, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as WearablesStrictHttpResponse<Array<DeviceLinkModel>>;
    })
  );
}

helpSupportedDevicesPlatformGet.PATH = '/Help/SupportedDevices/{platform}';
